import LayoutTypes from './LayoutTypes';

export function changeSize (panelName, sidebarName, size) {
  return {
    type: LayoutTypes.CHANGE_SIZE,
    payload: { panelName, sidebarName, size }
  };
}

export function changeMode (panelName, sidebarName, docked) {
  return {
    type: LayoutTypes.CHANGE_MODE,
    payload: { panelName, sidebarName, docked }
  };
}

export function changeVisibility (panelName, sidebarName, visible) {
  return {
    type: LayoutTypes.CHANGE_VISIBILITY,
    payload: { panelName, sidebarName, visible }
  };
}

export function changeFixed (panelName, sidebarName, fixed) {
  return {
    type: LayoutTypes.CHANGE_HEADER_FIXED,
    payload: { panelName, sidebarName, fixed }
  };
}

export function changeFullWidth (panelName, sidebarName, fullWidth) {
  return {
    type: LayoutTypes.CHANGE_HEADER_FULL_WIDTH,
    payload: { panelName, sidebarName, fullWidth }
  };
}

export function changeBackdropVisible (panelName, sidebarName, showBackdrop) {
  return {
    type: LayoutTypes.CHANGE_BACKDROP_VISIBLE,
    payload: { panelName, sidebarName, showBackdrop }
  };
}
